(function () {
  'use strict';

  function initAccordions(sectionEl) {
    sectionEl.querySelectorAll('.ingredients-card__header').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var card = btn.closest('.ingredients-card');
        var isOpen = card.classList.contains('is-open');

        // Close every other open accordion in this section
        sectionEl.querySelectorAll('.ingredients-card.is-open').forEach(function (openCard) {
          if (openCard !== card) {
            openCard.classList.remove('is-open');
            openCard.querySelector('.ingredients-card__header').setAttribute('aria-expanded', 'false');
          }
        });

        // Toggle the clicked one
        card.classList.toggle('is-open', !isOpen);
        btn.setAttribute('aria-expanded', String(!isOpen));
      });
    });
  }

  function initScrollAnimations(sectionEl) {
    var animatedEls = sectionEl.querySelectorAll('[data-animate], [data-heading-reveal]');
    if (!animatedEls.length) return;

    function reveal(el) {
      el.classList.add('is-visible');
    }

    // The cards reveal as one group. Their staggered delays live in the CSS
    // (150ms, 230ms, 310ms ...) and only read as a cascade if every card starts
    // counting from the same moment — watching each card separately restarted
    // the stagger at whatever scroll position that card happened to reach.
    // Threshold 0 here rather than 0.15: a tall accordion should start as soon
    // as its top edge shows, not once a fraction of the whole stack is in view.
    var groupObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          groupObserver.unobserve(entry.target);
          entry.target.querySelectorAll('[data-animate]').forEach(reveal);
        });
      },
      { threshold: 0, rootMargin: '0px 0px -100px 0px' },
    );

    var groups = sectionEl.querySelectorAll('.ingredients-section__cards');
    groups.forEach(function (group) {
      groupObserver.observe(group);
    });

    // Headings and anything animated outside a card group keep their own trigger.
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            reveal(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -100px 0px' },
    );

    animatedEls.forEach(function (el) {
      if (!el.closest('.ingredients-section__cards')) observer.observe(el);
    });
  }

  function initSection(sectionEl) {
    initAccordions(sectionEl);
    initScrollAnimations(sectionEl);
  }

  document.querySelectorAll('.ingredients-section').forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.ingredients-section');
    if (el) initSection(el);
  });
})();
